import ContentMapper from './ContentMapper'

export default ContentMapper
export { default as collector } from './collector'
